import React, { FC, memo } from 'react'

import { ConditionRender } from 'components'

import AutoStoryArticleStream from './AutoStoryArticleStream'
import AutoStoryArticleRadio from './AutoStoryArticleRadio'

import {
  AutoStoryArticleContainProps,
  IRadioAutoArgumentsStory,
  IStreamPlaylistAutoArgumentsStory
} from './AutoStoryArticleContain.props'

const AutoStoryArticleContain: FC<AutoStoryArticleContainProps> = memo(({ storyProperties, type }) => (
  <ConditionRender
    condition={type === 'stream'}
    component={<AutoStoryArticleStream storyProperties={storyProperties as IStreamPlaylistAutoArgumentsStory} />}
    secondComponent={<AutoStoryArticleRadio storyProperties={storyProperties as IRadioAutoArgumentsStory} />}
  />
))

export default AutoStoryArticleContain
